import React from 'react'

import { H2, Button } from '../Common'

import style from './SignInError.scss'

import drink from '../../images/emojis/drink.svg'

export default function() {
  return (
    <div className={style.wrapper}>
      <img src={drink} alt="" />
      <H2>seu trial acabou</H2>
      <p>
        entre em contato com a nossa equipe comercial e continue explorando tudo que a Hi Platform pode oferecer para o
        seu negócio.
      </p>
      <Button href="mailto:comercial@hiplatform.com.br?subject=Meu trial acabou" className={style.button} xl>
        comercial@hiplatform.com.br
      </Button>
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/components/Pages/SignInErrorTrialExpire.js